import { useAppConfig } from 'lib/config/common';
import { differenceInHours } from 'date-fns';
import { useState } from 'react';
import { useMedia } from 'react-use';

import { Button } from 'modules/core/components/buttons';
import PriceListOfficeViewModal from 'modules/prices/components/PriceListOfficeViewModal';

const WorkShiftInfoPanel = () => {
  const APPConf = useAppConfig();

  // Планшет/телефон (≤991px): панель рендерится внутри тёмного сайдбара (SideBar.jsx),
  // там outline-primary не виден на фиолетовом фоне, а место в полосе шапки ограничено —
  // кнопка сжимается до светлой иконки с title-подсказкой. На десктопе — с текстом.
  const isTabMobile = useMedia('(max-width: 991px)');
  // Телефон (≤575px, $mobileVerticalMaxWidth): офис переносится на свою строку —
  // кнопку ставим слева от названия в одну строку с ним
  const isPhone = useMedia('(max-width: 575px)');

  const [showPriceModal, setShowPriceModal] = useState(false);

  const office = APPConf?.officeFromLocalStorage;

  const showExtendButton = APPConf?.executorsCreatedAt
    ? differenceInHours(
      new Date(),
      new Date(APPConf.executorsCreatedAt * 1000)
    ) > 12
    : false;

  const priceButton = office?.id && (
    <Button
      className={ isPhone ? 'mr-2' : (isTabMobile ? 'ml-2' : 'ml-3') }
      size={ isTabMobile ? 'sm' : undefined }
      variant={ isTabMobile ? 'light' : 'outline-primary' }
      icon='tag'
      text={ isTabMobile ? undefined : 'Посмотреть прайс' }
      title={ isTabMobile ? 'Посмотреть прайс' : undefined }
      onClick={ () => setShowPriceModal(true) }
    />
  );

  return (
    <div className='header-work-shift'>
      <div className='d-flex align-items-center'>
        { isPhone && priceButton }
        <div className='header-office-name'>
          { office?.name }
        </div>
        { !isPhone && priceButton }
      </div>
      { showExtendButton && (
        <div className='header-extend-work-shift'>
          Продлите смену
        </div>
      ) }
      { showPriceModal && (
        <PriceListOfficeViewModal
          show
          officeId={ office.id }
          officeName={ office.name }
          onClose={ () => setShowPriceModal(false) }
        />
      ) }
    </div>
  );
};

export default WorkShiftInfoPanel;
